module.exports = __webpack_public_path__ + "static/media/qiXi_success_download.1bb5b2fc.png";